(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("LabelInsightAuth", [], factory);
	else if(typeof exports === 'object')
		exports["LabelInsightAuth"] = factory();
	else
		root["LabelInsightAuth"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(1);

	var _Auth = __webpack_require__(2);

	var _Auth2 = _interopRequireDefault(_Auth);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports['default'] = _Auth2.default;
	module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';

	(function (self) {
	  'use strict';

	  if (self.fetch) {
	    return;
	  }

	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && function () {
	      try {
	        new Blob();
	        return true;
	      } catch (e) {
	        return false;
	      }
	    }(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  };

	  if (support.arrayBuffer) {
	    var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];

	    var isDataView = function isDataView(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj);
	    };

	    var isArrayBufferView = ArrayBuffer.isView || function (obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
	    };
	  }

	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name');
	    }
	    return name.toLowerCase();
	  }

	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value;
	  }

	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function next() {
	        var value = items.shift();
	        return { done: value === undefined, value: value };
	      }
	    };

	    if (support.iterable) {
	      iterator[Symbol.iterator] = function () {
	        return iterator;
	      };
	    }

	    return iterator;
	  }

	  function Headers(headers) {
	    this.map = {};

	    if (headers instanceof Headers) {
	      headers.forEach(function (value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function (name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }

	  Headers.prototype.append = function (name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var list = this.map[name];
	    if (!list) {
	      list = [];
	      this.map[name] = list;
	    }
	    list.push(value);
	  };

	  Headers.prototype['delete'] = function (name) {
	    delete this.map[normalizeName(name)];
	  };

	  Headers.prototype.get = function (name) {
	    var values = this.map[normalizeName(name)];
	    return values ? values[0] : null;
	  };

	  Headers.prototype.getAll = function (name) {
	    return this.map[normalizeName(name)] || [];
	  };

	  Headers.prototype.has = function (name) {
	    return this.map.hasOwnProperty(normalizeName(name));
	  };

	  Headers.prototype.set = function (name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)];
	  };

	  Headers.prototype.forEach = function (callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function (name) {
	      this.map[name].forEach(function (value) {
	        callback.call(thisArg, value, name, this);
	      }, this);
	    }, this);
	  };

	  Headers.prototype.keys = function () {
	    var items = [];
	    this.forEach(function (value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items);
	  };

	  Headers.prototype.values = function () {
	    var items = [];
	    this.forEach(function (value) {
	      items.push(value);
	    });
	    return iteratorFor(items);
	  };

	  Headers.prototype.entries = function () {
	    var items = [];
	    this.forEach(function (value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items);
	  };

	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }

	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'));
	    }
	    body.bodyUsed = true;
	  }

	  function fileReaderReady(reader) {
	    return new Promise(function (resolve, reject) {
	      reader.onload = function () {
	        resolve(reader.result);
	      };
	      reader.onerror = function () {
	        reject(reader.error);
	      };
	    });
	  }

	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise;
	  }

	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsText(blob);
	    return promise;
	  }

	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);

	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('');
	  }

	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0);
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer;
	    }
	  }

	  function Body() {
	    this.bodyUsed = false;

	    this._initBody = function (body) {
	      this._bodyInit = body;
	      if (!body) {
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        throw new Error('unsupported BodyInit type');
	      }

	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };

	    if (support.blob) {
	      this.blob = function () {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected;
	        }

	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob);
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob');
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]));
	        }
	      };

	      this.arrayBuffer = function () {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer);
	        }
	      };
	    }

	    this.text = function () {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected;
	      }

	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob);
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text');
	      } else {
	        return Promise.resolve(this._bodyText);
	      }
	    };

	    if (support.formData) {
	      this.formData = function () {
	        return this.text().then(decode);
	      };
	    }

	    this.json = function () {
	      return this.text().then(JSON.parse);
	    };

	    return this;
	  }

	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method;
	  }

	  function Request(input, options) {
	    options = options || {};
	    var body = options.body;

	    if (typeof input === 'string') {
	      this.url = input;
	    } else {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read');
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    }

	    this.credentials = options.credentials || this.credentials || 'omit';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.referrer = null;

	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests');
	    }
	    this._initBody(body);
	  }

	  Request.prototype.clone = function () {
	    return new Request(this, { body: this._bodyInit });
	  };

	  function decode(body) {
	    var form = new FormData();
	    body.trim().split('&').forEach(function (bytes) {
	      if (bytes) {
	        var split = bytes.split('=');
	        var name = split.shift().replace(/\+/g, ' ');
	        var value = split.join('=').replace(/\+/g, ' ');
	        form.append(decodeURIComponent(name), decodeURIComponent(value));
	      }
	    });
	    return form;
	  }

	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    rawHeaders.split('\r\n').forEach(function (line) {
	      var parts = line.split(':');
	      var key = parts.shift().trim();
	      if (key) {
	        var value = parts.join(':').trim();
	        headers.append(key, value);
	      }
	    });
	    return headers;
	  }

	  Body.call(Request.prototype);

	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {};
	    }

	    this.type = 'default';
	    this.status = 'status' in options ? options.status : 200;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = 'statusText' in options ? options.statusText : 'OK';
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }

	  Body.call(Response.prototype);

	  Response.prototype.clone = function () {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    });
	  };

	  Response.error = function () {
	    var response = new Response(null, { status: 0, statusText: '' });
	    response.type = 'error';
	    return response;
	  };

	  var redirectStatuses = [301, 302, 303, 307, 308];

	  Response.redirect = function (url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code');
	    }

	    return new Response(null, { status: status, headers: { location: url } });
	  };

	  self.Headers = Headers;
	  self.Request = Request;
	  self.Response = Response;

	  self.fetch = function (input, init) {
	    return new Promise(function (resolve, reject) {
	      var request = new Request(input, init);
	      var xhr = new XMLHttpRequest();

	      xhr.onload = function () {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options));
	      };

	      xhr.onerror = function () {
	        reject(new TypeError('Network request failed'));
	      };

	      xhr.ontimeout = function () {
	        reject(new TypeError('Network request failed'));
	      };

	      xhr.open(request.method, request.url, true);

	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      }

	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob';
	      }

	      request.headers.forEach(function (value, name) {
	        xhr.setRequestHeader(name, value);
	      });

	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    });
	  };
	  self.fetch.polyfill = true;
	})(typeof self !== 'undefined' ? self : undefined);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _jsCookie = __webpack_require__(3);

	var _jsCookie2 = _interopRequireDefault(_jsCookie);

	var _store = __webpack_require__(4);

	var _store2 = _interopRequireDefault(_store);

	var _Requests = __webpack_require__(5);

	var _Requests2 = _interopRequireDefault(_Requests);

	var _util = __webpack_require__(6);

	var util = _interopRequireWildcard(_util);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Auth = function () {
	  function Auth() {
	    var _this = this;

	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	    _classCallCheck(this, Auth);

	    this.getUser = _store2.default.getUser;
	    this.getImpersonatedUser = _store2.default.getImpersonatedUser;
	    this.getToken = _store2.default.getToken;
	    this.getTokenExpiresAt = _store2.default.getTokenExpiresAt;

	    this.login = function (userData) {
	      return _this.requests.login(userData).then(_this.createLoginResponseHandler(userData.email));
	    };

	    this.secondFactor = function (code) {
	      return _this.requests.secondFactor(code).then(_this.createLoginResponseHandler());
	    };

	    this.createLoginResponseHandler = function (email) {
	      return function (data) {
	        var authenticationToken = data.authenticationToken;


	        if (authenticationToken) {
	          _this.saveToken(authenticationToken.accessToken);
	        }

	        return email ? _extends({ email: email }, data) : data;
	      };
	    };

	    this.user = function () {
	      return _this.requests.user().then(function (user) {
	        _store2.default.setUser(user);
	        return user;
	      });
	    };

	    this.logout = function () {
	      _store2.default.delete();
	      // return promise for backwards compat
	      return Promise.resolve(200);
	    };

	    this.run = function () {
	      if (_this.getToken()) {
	        var user = _this.getUser();
	        return user ? Promise.resolve(user) : _this.user();
	      }
	      return _this.onRunFailure(new Error('[auth.run] no token'));
	    };

	    this.onRunFailure = function (err) {
	      _store2.default.delete();
	      return Promise.reject(err);
	    };

	    this.impersonate = function (email) {
	      return _this.requests.impersonate(email).then(function (impersonatedUser) {
	        _store2.default.setImpersonatedUser(impersonatedUser);
	        return impersonatedUser;
	      });
	    };

	    this.stopImpersonating = _store2.default.deleteImpersonatedUser;

	    this.renewToken = function (token) {
	      return _this.requests.renewToken(token).then(function (body) {
	        _this.saveToken(body.authenticationToken.accessToken);
	      });
	    };

	    this.saveToken = function (token) {
	      var parsedToken = util.parseToken(token);
	      var expires = new Date(_this.config.expires ? parsedToken.iat * 1000 + _this.config.expires * 1000 : parsedToken.exp * 1000);
	      _store2.default.setToken(token, { expires: expires });
	      _store2.default.setTokenExpiresAt(expires.toISOString());
	    };

	    this.config = _extends({}, Auth.defaultConfig, config);
	    this.requests = new _Requests2.default(this.config.env);
	    this.resetPassword = this.requests.resetPassword;
	    this.updatePassword = this.requests.updatePassword;
	    this.sendVerification = this.requests.sendVerification;
	    this.verify = this.requests.verify;

	    _store2.default.deleteLegacy();
	    _store2.default.deleteBloatware();
	  }

	  _createClass(Auth, [{
	    key: 'cookie',


	    // eslint-disable-next-line class-methods-use-this
	    get: function get() {
	      console.warn('[auth] `auth.cookie` is deprecated. ' + 'Use `auth.(getUser|getImpersonatedUser|getToken)` instead');
	      return _store2.default;
	    }
	  }]);

	  return Auth;
	}();

	Auth.defaultConfig = { env: 'production' };
	Auth.CookieLibrary = _jsCookie2.default;
	Auth.store = _store2.default;
	Auth.util = util;
	exports.default = Auth;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	/*!
	 * JavaScript Cookie v2.2.0
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader = false;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (( false ? 'undefined' : _typeof(exports)) === 'object') {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	})(function () {
		function extend() {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[i];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}

		function init(converter) {
			function api(key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}

				// Write

				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);

					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}

					// We're using "expires" because "max-age" is not supported by IE
					attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}

					if (!converter.write) {
						value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}

					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);

					var stringifiedAttributes = '';

					for (var attributeName in attributes) {
						if (!attributes[attributeName]) {
							continue;
						}
						stringifiedAttributes += '; ' + attributeName;
						if (attributes[attributeName] === true) {
							continue;
						}
						stringifiedAttributes += '=' + attributes[attributeName];
					}
					return document.cookie = key + '=' + value + stringifiedAttributes;
				}

				// Read

				if (!key) {
					result = {};
				}

				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;

				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');

					if (!this.json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}

					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ? converter.read(cookie, name) : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);

						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}

						if (key === name) {
							result = cookie;
							break;
						}

						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}

				return result;
			}

			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};

			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};

			api.withConverter = init;

			return api;
		}

		return init(function () {});
	});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _jsCookie = __webpack_require__(3);

	var _jsCookie2 = _interopRequireDefault(_jsCookie);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var getJSON = _jsCookie2.default.getJSON.bind(_jsCookie2.default);

	var names = {
	  legacy: 'li.auth',
	  user: 'li.auth2.user',
	  impersonatedUser: 'li.auth2.impersonatedUser',
	  token: 'li.auth2.token',
	  tokenExpiresAt: 'li.auth2.tokenExpiresAt'
	};

	var isLocalHost = function isLocalHost() {
	  return window.location.hostname === 'localhost';
	};
	var conditionallyAddDomain = function conditionallyAddDomain() {
	  return isLocalHost() ? undefined : { domain: '.labelinsight.com' };
	};

	var remove = function remove(name) {
	  return _jsCookie2.default.remove(name, conditionallyAddDomain());
	};

	var set = function set(name, cookie) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	  var opts = _extends({}, options);
	  if (!isLocalHost()) {
	    opts.domain = '.labelinsight.com';
	  }
	  _jsCookie2.default.set(name, cookie, opts);
	};

	var setUser = function setUser(user) {
	  return localStorage.setItem(names.user, JSON.stringify(user));
	};

	var setImpersonatedUser = function setImpersonatedUser(impersonatedUser) {
	  return localStorage.setItem(names.impersonatedUser, JSON.stringify(impersonatedUser));
	};

	var setToken = set.bind(null, names.token);
	var setTokenExpiresAt = set.bind(null, names.tokenExpiresAt);

	var getUser = function getUser() {
	  var user = localStorage.getItem(names.user);
	  return user && JSON.parse(user);
	};

	var getImpersonatedUser = function getImpersonatedUser() {
	  var user = localStorage.getItem(names.impersonatedUser);
	  return user && JSON.parse(user);
	};

	var getToken = function getToken() {
	  return getJSON(names.token);
	};

	var getTokenExpiresAt = function getTokenExpiresAt() {
	  return _jsCookie2.default.get(names.tokenExpiresAt);
	};

	exports.default = {
	  names: names,
	  setUser: setUser,
	  setImpersonatedUser: setImpersonatedUser,
	  setToken: setToken,
	  setTokenExpiresAt: setTokenExpiresAt,
	  getUser: getUser,
	  getImpersonatedUser: getImpersonatedUser,
	  getToken: getToken,
	  getTokenExpiresAt: getTokenExpiresAt,

	  deleteBloatware: function deleteBloatware(documentCookie) {
	    try {
	      var _names = (documentCookie || document.cookie).match(/([^\s;=]+)(?==.+;)/g);
	      if (_names) {
	        _names.forEach(function (name) {
	          return (/^mp_|mixpanel/.test(name) && remove(name)
	          );
	        });
	      }
	    } catch (err) {
	      console.error('[auth.deleteBloatware]', err);
	    }
	  },
	  deleteLegacy: function deleteLegacy() {
	    remove(names.legacy);
	  },
	  delete: function _delete() {
	    remove(names.token);
	    remove(names.tokenExpiresAt);
	    localStorage.removeItem(names.user);
	    localStorage.removeItem(names.impersonatedUser);
	  },
	  deleteImpersonatedUser: function deleteImpersonatedUser() {
	    localStorage.removeItem(names.impersonatedUser);
	  },
	  get: function get() {
	    console.warn('[auth] `auth.cookie.get` is deprecated. ' + 'Use `auth.(getUser|getImpersonatedUser|getToken)` instead.');

	    var user = getUser();
	    if (!user) return;
	    var ret = { user: user };

	    var impersonatedUser = getImpersonatedUser();
	    var token = getToken();
	    if (impersonatedUser) {
	      ret.impersonatedUser = impersonatedUser;
	      ret.impersonated = impersonatedUser.email;
	    }
	    if (token) ret.token = token;

	    // eslint-disable-next-line consistent-return
	    return ret;
	  }
	};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _templateObject = _taggedTemplateLiteral(['/rest/oauth/login/', ''], ['/rest/oauth/login/', '']),
	    _templateObject2 = _taggedTemplateLiteral(['/rest/user/', '/'], ['/rest/user/', '/']);

	var _store = __webpack_require__(4);

	var _store2 = _interopRequireDefault(_store);

	var _util = __webpack_require__(6);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Requests = function () {
	  function Requests(env) {
	    var _this = this;

	    _classCallCheck(this, Requests);

	    this.endpoints = {
	      login: '/rest/oauth/login',
	      user: '/rest/user',
	      secondFactor: (0, _util.params)(_templateObject, 0),
	      resetPassword: '/rest/email/passwordreset/send',
	      updatePassword: '/rest/oauth/passwordreset',
	      sendVerification: '/rest/email/verification/send',
	      verify: '/rest/oauth/verify',
	      impersonate: (0, _util.params)(_templateObject2, 0),
	      renewToken: '/rest/oauth/login/renew'
	    };

	    this.getEndpoint = function (id) {
	      var _endpoints;

	      for (var _len = arguments.length, queryParams = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        queryParams[_key - 1] = arguments[_key];
	      }

	      var endpoint = queryParams.length ? (_endpoints = _this.endpoints)[id].apply(_endpoints, _toConsumableArray(queryParams)) : _this.endpoints[id];

	      return _this.domain + endpoint;
	    };

	    this.request = function (id) {
	      for (var _len2 = arguments.length, params = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        params[_key2 - 1] = arguments[_key2];
	      }

	      var url = _this.getEndpoint.apply(_this, [id].concat(_toConsumableArray(params)));

	      return function () {
	        var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	        var fetchInit = _extends({
	          credentials: 'include',
	          mode: 'cors'
	        }, init);

	        return fetch(url, fetchInit).then(Requests.preResponseHandle);
	      };
	    };

	    this.getAuthorizationHeader = function () {
	      return {
	        Authorization: 'Bearer ' + (_store2.default.getToken() || '')
	      };
	    };

	    this.withAuthorizationHeader = function () {
	      var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { headers: {} };
	      return _extends({}, init, {
	        headers: _extends({}, init.headers, _this.getAuthorizationHeader())
	      });
	    };

	    this.login = function (userData) {
	      return _this.request('login')(Requests.post(_extends({
	        agreement: false,
	        rememberMe: true
	      }, userData)));
	    };

	    this.user = function () {
	      return _this.request('user')(_this.withAuthorizationHeader());
	    };

	    this.secondFactor = function (code) {
	      return _this.request('secondFactor', code)(Requests.post());
	    };

	    this.resetPassword = function (email) {
	      return _this.request('resetPassword')(Requests.post({ email: email }));
	    };

	    this.updatePassword = function (data) {
	      return _this.request('updatePassword')(Requests.post(data));
	    };

	    this.sendVerification = function (email) {
	      return _this.request('sendVerification')(Requests.post({ email: email }));
	    };

	    this.verify = function (token) {
	      return _this.request('verify')(Requests.post({ token: token }));
	    };

	    this.impersonate = function (email) {
	      return _this.request('impersonate', email)(_this.withAuthorizationHeader());
	    };

	    this.renewToken = function (token) {
	      return _this.request('renewToken')(Requests.post(token));
	    };

	    this.domain = 'https://' + (env === 'production' ? 'external-api' : 'dev-external-api') + '.labelinsight.com/labelinsight-security-api';
	  }

	  _createClass(Requests, null, [{
	    key: 'post',
	    value: function post(data) {
	      var init = { method: 'POST' };

	      if (data) {
	        init.headers = { 'Content-Type': 'application/json' };
	        init.body = typeof data === 'object' ? JSON.stringify(data) : data;
	      }

	      return init;
	    }
	  }, {
	    key: 'preResponseHandle',
	    value: function preResponseHandle(res) {
	      if (res.ok) return res.status === 204 || res.json();
	      throw res;
	    }
	  }]);

	  return Requests;
	}();

	exports.default = Requests;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.params = params;
	exports.isString = isString;
	exports.parseToken = parseToken;

	var _jwtDecode = __webpack_require__(7);

	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * Template literal tag function
	 *
	 * @example
	 * ```js
	 * const endpoint = params`https://foo.com/${0}/${1}`
	 * endpoint(`bar`, 'baz') // => https://foo.com/bar/baz
	 * ```
	 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals
	 */
	function params(strings) {
	  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    keys[_key - 1] = arguments[_key];
	  }

	  return function () {
	    for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      values[_key2] = arguments[_key2];
	    }

	    var result = [strings[0]];

	    keys.forEach(function (key, i) {
	      var value = values[key];
	      result.push(value, strings[i + 1]);
	    });

	    return result.join('');
	  };
	}

	function isString(str) {
	  return typeof str === 'string' || str instanceof String;
	}

	function parseToken(token) {
	  try {
	    return (0, _jwtDecode2.default)(token);
	  } catch (ignore) {
	    //
	  }

	  return undefined;
	}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var base64_url_decode = __webpack_require__(8);

	function InvalidTokenError(message) {
	  this.message = message;
	}

	InvalidTokenError.prototype = new Error();
	InvalidTokenError.prototype.name = 'InvalidTokenError';

	module.exports = function (token, options) {
	  if (typeof token !== 'string') {
	    throw new InvalidTokenError('Invalid token specified');
	  }

	  options = options || {};
	  var pos = options.header === true ? 0 : 1;
	  try {
	    return JSON.parse(base64_url_decode(token.split('.')[pos]));
	  } catch (e) {
	    throw new InvalidTokenError('Invalid token specified: ' + e.message);
	  }
	};

	module.exports.InvalidTokenError = InvalidTokenError;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var atob = __webpack_require__(9);

	function b64DecodeUnicode(str) {
	  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
	    var code = p.charCodeAt(0).toString(16).toUpperCase();
	    if (code.length < 2) {
	      code = '0' + code;
	    }
	    return '%' + code;
	  }));
	}

	module.exports = function (str) {
	  var output = str.replace(/-/g, "+").replace(/_/g, "/");
	  switch (output.length % 4) {
	    case 0:
	      break;
	    case 2:
	      output += "==";
	      break;
	    case 3:
	      output += "=";
	      break;
	    default:
	      throw "Illegal base64url string!";
	  }

	  try {
	    return b64DecodeUnicode(output);
	  } catch (err) {
	    return atob(output);
	  }
	};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';

	/**
	 * The code was extracted from:
	 * https://github.com/davidchambers/Base64.js
	 */

	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

	function InvalidCharacterError(message) {
	  this.message = message;
	}

	InvalidCharacterError.prototype = new Error();
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';

	function polyfill(input) {
	  var str = String(input).replace(/=+$/, '');
	  if (str.length % 4 == 1) {
	    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
	  }
	  for (
	  // initialize result and counters
	  var bc = 0, bs, buffer, idx = 0, output = '';
	  // get next character
	  buffer = str.charAt(idx++);
	  // character found in table? initialize bit storage and add its ascii value;
	  ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
	  // and if not first of each 4 characters,
	  // convert the first 8 bits to one ascii character
	  bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
	    // try to find character in table (0-63, not found => -1)
	    buffer = chars.indexOf(buffer);
	  }
	  return output;
	}

	module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;

/***/ })
/******/ ])
});
;


//////////////////
// WEBPACK FOOTER
// ./~/label-insight-auth/dist/Auth.js
// module id = 195
// module chunks = 14